import { useEffect } from "react";
import { ADDRESS, PHONE } from "@/lib/site";

const CONTENT = {
  privacy: {
    title: "Privacy Policy",
    sections: [
      ["Information we collect", "When you submit our contact form, we collect the details you provide: your name, mobile number, email address, business name, website type, budget range and project requirements. When you contact us on WhatsApp or by phone, we receive the information you choose to share."],
      ["How we use your information", "We use your information only to respond to your enquiry, prepare quotations, communicate about your project and provide our website designing services. We do not sell your personal information."],
      ["Third-party services", "Our website may use third-party services such as WhatsApp, Google Maps and website analytics tools. These services may process data according to their own privacy policies."],
      ["Data security", "We take reasonable measures to protect the information you submit. However, no method of transmission over the internet is completely secure."],
      ["Your choices", "You may request access to, correction of, or deletion of your personal information by contacting us using the details below."],
      ["Contact", `Pratap Group, ${ADDRESS}. Phone / WhatsApp: ${PHONE}.`],
    ],
  },
  terms: {
    title: "Terms & Conditions",
    sections: [
      ["Use of this website", "By using this website, you agree to these terms. The content on this website is for general information about Pratap Group's website designing and development services."],
      ["Quotations & pricing", "Package prices shown on this website cover the listed package features. Final pricing, domain, hosting, maintenance, and third-party service costs depend on project requirements and will be confirmed in writing before work begins."],
      ["Portfolio concepts", "Website designs shown in our portfolio are sample concepts created to demonstrate our design style unless clearly stated otherwise. They are not completed client projects."],
      ["Client responsibilities", "Clients are responsible for providing accurate content, images and information for their websites, and for ensuring they have the rights to use any material they supply."],
      ["Third-party services", "Domain registration, hosting, payment gateways and other third-party services are subject to the terms and charges of their respective providers."],
      ["Contact", `For any questions about these terms, contact Pratap Group at ${PHONE}.`],
    ],
  },
};

export default function Legal({ kind }) {
  const c = CONTENT[kind];
  useEffect(() => { document.title = `${c.title} | Pratap Group`; window.scrollTo(0, 0); }, [c.title]);
  return (
    <main data-testid={`${kind}-page`} className="mx-auto max-w-3xl px-5 pb-24 pt-40 sm:px-8">
      <p className="text-xs font-semibold uppercase tracking-[0.3em] text-[var(--gold)]">Legal</p>
      <h1 className="font-display mt-4 text-4xl font-semibold text-white sm:text-5xl">{c.title}</h1>
      <p className="mt-4 text-sm text-slate-400">Pratap Group · Noida, Uttar Pradesh, India</p>
      <div className="mt-14 space-y-10">
        {c.sections.map(([h, p]) => (
          <section key={h}>
            <h2 className="font-display text-xl font-semibold text-white">{h}</h2>
            <p className="mt-3 leading-relaxed text-slate-300">{p}</p>
          </section>
        ))}
      </div>
    </main>
  );
}
